import Events from 'actions/events';

export default Events.createReducer();